import { render, staticRenderFns } from "./ForgetPasswordVerify.vue?vue&type=template&id=2ba72595&scoped=true"
import script from "./ForgetPasswordVerify.vue?vue&type=script&lang=js"
export * from "./ForgetPasswordVerify.vue?vue&type=script&lang=js"
import style0 from "./ForgetPasswordVerify.vue?vue&type=style&index=0&id=2ba72595&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba72595",
  null
  
)

export default component.exports